import script from "./ShiftCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ShiftCard.vue?vue&type=script&setup=true&lang=js"

import "./ShiftCard.vue?vue&type=style&index=0&id=161c0388&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-161c0388"]])

export default __exports__